import { Chargement } from "@/composants/ui/etats";
import { PageConnexionClient } from "@/client/pages/connexion";
import { PageTableauClient } from "@/client/pages/tableau";
import { useSessionClient } from "@/client/session";

export function AppClient() {
  const session = useSessionClient();
  if (session.statut === "chargement") return <Chargement />;
  if (session.statut === "anonyme") return <PageConnexionClient />;
  return <PageTableauClient />;
}
